import styles from "./style.module.css";
import { Box, Grid, Typography, Button } from "@mui/material";
import { useEffect, useState } from "react";
import AdminApi from "../../../config/apis/admin";
import { api } from "../../../config/apis";
import {
  DataLoader,
  getStartAndEndOfMonth,
  getStartAndEndOfWeek,
  getStartAndEndOfYear,
} from "../../../helper/helperFunction";
import FilterButtons from "./FilterButton";
import FilterMultiSelect from "./FilterMultiSelect";

export const Sponsors = (params) => {
  const [filters, setFilters] = useState();
  const [activeButton, setActiveButton] = useState("soFar");

  const [sponsorsData, setSponsorsData] = useState();
  const [loading, setLoading] = useState(true);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2023 + 1 }, (_, i) => {
    const year = currentYear - i;
    return { id: year, name: year.toString() };
  });
  const months = [
    { id: 1, name: "Jan" },
    { id: 2, name: "Feb" },
    { id: 3, name: "Mar" },
    { id: 4, name: "Apr" },
    { id: 5, name: "May" },
    { id: 6, name: "Jun" },
    { id: 7, name: "Jul" },
    { id: 8, name: "Aug" },
    { id: 9, name: "Sep" },
    { id: 10, name: "Oct" },
    { id: 11, name: "Nov" },
    { id: 12, name: "Dec" },
  ];

  const handleUpdate = (name, value) => {
    setFilters((prevState) => {
      const updatedFilters = {
        ...prevState,
        [name]: value,
      };
      if (name === "year" || name === "month") {
        delete updatedFilters.from_date;
        delete updatedFilters.to_date;
      }
      if (name === "year") {
        if (!value || value.length === 0) {
          delete updatedFilters.month;
        }
      }
      return updatedFilters;
    });
    setActiveButton("");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // Modify the API call with parameters
        const res = await api.get(AdminApi.DASH_SPONSER_COUNT, {
          params: {
            filters: {
              ...filters,
            },
          },
        });

        setSponsorsData(res.data.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [filters]);

  const handleCurrentYear = () => {
    setFilters({
      year: new Date().getFullYear(),
    });
    setActiveButton("currentYear");
  };
  const handleCurrentMonth = () => {
    const { startOfMonth, endOfMonth } = getStartAndEndOfMonth();

    setFilters({
      from_date: startOfMonth,
      to_date: endOfMonth,
    });
    setActiveButton("currentMonth");
  };
  const handleThisWeek = () => {
    const { startOfWeek, endOfWeek } = getStartAndEndOfWeek();

    setFilters({
      from_date: startOfWeek,
      to_date: endOfWeek,
    });
    setActiveButton("thisWeek");
  };
  const handleSoFar = () => {
    setFilters();
    setActiveButton("soFar");
  };

  return (
    <>
      {loading ? (
        <DataLoader />
      ) : (
        <>
          {params.filter && (
            <FilterButtons
              activeButton={activeButton}
              handleSoFar={handleSoFar}
              handleThisWeek={handleThisWeek}
              handleCurrentMonth={handleCurrentMonth}
              handleCurrentYear={handleCurrentYear}
            />
          )}

          <Grid container marginTop={2}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                pl: "30px",
              }}
            >
              <Box sx={{ maxWidth: "220px", width: "100%" }}>
                <FilterMultiSelect
                  options={years}
                  formData={
                    activeButton === "currentYear"
                      ? { ...filters, year: undefined }
                      : filters
                  }
                  onUpdate={handleUpdate}
                  labelKey="name"
                  name="year"
                  valueKey="id"
                  errorText=""
                  defaultText="Select Year"
                />
              </Box>
              <Box sx={{ maxWidth: "150px", width: "100%" }}>
                <FilterMultiSelect
                  options={months}
                  formData={filters}
                  onUpdate={handleUpdate}
                  labelKey="name"
                  name="month"
                  valueKey="id"
                  errorText=""
                  defaultText="Select Month"
                  disabled={
                    activeButton === "currentYear" ||
                    !filters?.year ||
                    (Array.isArray(filters.year) && filters.year.length === 0)
                  }
                />
              </Box>
            </Box>
          </Grid>

          <Grid
            container
            marginTop={2}
            className={styles.totalJobsContainer_wrap}
          >
            <Grid item xs={12}>
              <Box
                className={`${styles.totalJobsContainer} ${styles.totalJobsContainer_after}`}
              >
                <Box className={styles.left_box}>
                  <Typography variant="h6">Sponsors</Typography>
                  <Typography variant="h4">
                    {sponsorsData && sponsorsData.sponsors}
                  </Typography>
                </Box>
                <Box className={styles.imageContainer}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="31"
                    height="35"
                    viewBox="0 0 31 35"
                    fill="none"
                  >
                    <path
                      d="M24.6688 26.6411C22.7429 27.9327 21.0549 28.7094 19.5364 29.1148C19.6808 28.391 19.4984 27.6111 18.9776 27.0194C18.5722 26.5611 18.0276 26.2904 17.4591 26.2176C17.3605 25.896 17.1942 25.5911 16.9583 25.3243C16.4117 24.703 15.6099 24.429 14.841 24.5167C14.7495 24.3394 14.6367 24.1712 14.4994 24.0159C13.7685 23.1864 12.5845 22.9743 11.6274 23.4203C11.5784 23.3488 11.5229 23.2818 11.4649 23.2141C10.5787 22.2093 9.02023 22.1107 8.01541 22.9988L6.29773 24.5115C5.97095 24.8022 5.73892 25.1619 5.6055 25.5531C5.55072 25.5402 5.49593 25.5254 5.44115 25.5144C5.47595 25.4287 5.50496 25.341 5.52494 25.2476L7.33349 16.781C7.35734 16.6695 7.3683 16.5599 7.36636 16.4504L8.10822 16.6096C9.20263 16.2828 10.3209 15.9096 11.472 15.577L9.56099 17.3585C8.80818 18.0604 8.06439 19.1181 8.60902 20.1738C9.2007 21.323 10.7321 21.3063 11.8156 21.0652C12.87 20.8313 13.9038 20.3363 14.7952 19.693C16.783 22.2621 19.907 23.0568 22.5676 24.7848C23.3604 25.3004 24.0823 25.894 24.6688 26.6411ZM25.6659 16.781C25.642 16.6695 25.6311 16.5599 25.633 16.4504L24.5844 16.6753C21.7252 14.9415 18.2867 14.1172 13.8581 14.9815C13.7943 14.9924 13.7427 15.0202 13.6957 15.064L10.3396 18.1938C7.85492 20.4884 11.88 20.8319 14.7482 18.2705C14.8249 18.2029 14.9164 18.1758 15.0189 18.19C15.1194 18.2048 15.2 18.2596 15.2528 18.3453C17.5313 22.1126 22.7874 22.3395 25.6047 25.9856L27.5814 25.5634C27.5357 25.4648 27.4989 25.3591 27.4757 25.2476L25.6659 16.781ZM10.5033 25.7993C11.0318 25.323 11.0795 24.5032 10.6096 23.9682C10.1346 23.4313 9.30705 23.3778 8.77015 23.8528L7.05248 25.3655C6.51558 25.8406 6.46209 26.6681 6.9371 27.207C7.41019 27.7439 8.2397 27.7954 8.7766 27.3223L10.0721 26.1796C10.0773 26.1751 10.0811 26.1699 10.0863 26.1654L10.5033 25.7993ZM13.5461 26.594C14.0669 26.1164 14.1146 25.3017 13.6447 24.7687C13.1697 24.2318 12.3421 24.1802 11.8052 24.6533L10.5039 25.7993C10.5001 25.8025 10.4969 25.8064 10.4936 25.8096L10.074 26.1796C9.55068 26.6565 9.50234 27.4732 9.97285 28.0075C10.4479 28.5444 11.2754 28.5979 11.8123 28.1228L12.5303 27.4906C12.5361 27.4854 12.5413 27.4796 12.5471 27.4744L13.5461 26.594ZM15.9902 27.9166C16.5258 27.4416 16.578 26.6153 16.1036 26.0765C15.6305 25.5396 14.801 25.4861 14.2641 25.9611L13.5461 26.5934C13.5403 26.5985 13.5352 26.6043 13.5294 26.6095L12.5297 27.4899C12.0089 27.9675 11.9632 28.7822 12.4311 29.3152C12.9061 29.8521 13.7337 29.9056 14.2706 29.4306L15.8039 28.0797L15.8052 28.0784L15.9902 27.9166ZM16.2828 27.6588L15.9902 27.9166C15.9895 27.9172 15.9889 27.9179 15.9883 27.9185L15.8046 28.0803C15.2683 28.5534 15.2161 29.3823 15.6905 29.9191C16.1636 30.456 16.9931 30.5095 17.53 30.0345L18.0069 29.6143C18.5438 29.1412 18.5973 28.3136 18.1223 27.7748C17.6492 27.2366 16.8197 27.1838 16.2828 27.6588ZM5.96386 16.1507L2.20947 15.3489C2.03222 15.3102 1.85498 15.4236 1.81695 15.6028L0.00774937 24.0687C-0.0309225 24.246 0.0844486 24.4232 0.261695 24.4613L4.01609 25.2631C4.19527 25.3017 4.37058 25.1864 4.40861 25.0091L6.2191 16.5425C6.25584 16.364 6.1424 16.1887 5.96386 16.1507ZM32.9923 24.0687L31.1837 15.6022C31.1451 15.423 30.9685 15.3096 30.7912 15.3482L27.0349 16.15C26.8576 16.1887 26.7423 16.364 26.7809 16.5425L28.5895 25.0091C28.6275 25.1864 28.8048 25.3017 28.982 25.2631L32.7383 24.4613C32.9156 24.4232 33.031 24.246 32.9923 24.0687ZM8.61095 6.90036C8.61095 4.54911 10.5181 2.6413 12.87 2.6413C14.0025 2.6413 15.0331 3.08538 15.7968 3.80661C15.1736 4.67802 14.8068 5.74665 14.8068 6.89971C14.8068 8.05278 15.1742 9.12141 15.7968 9.99282C15.0331 10.7147 14.0025 11.1581 12.87 11.1581C10.5181 11.1588 8.61095 9.25161 8.61095 6.90036ZM11.2 8.02378C11.2568 8.15913 11.3206 8.27966 11.3934 8.38923C11.6435 8.77272 11.9799 9.01571 12.3383 9.14591V9.51651C12.3383 9.81042 12.5755 10.0482 12.87 10.0482C13.1639 10.0482 13.4018 9.81042 13.4018 9.51651V9.20778C13.4984 9.18587 13.5919 9.15493 13.6795 9.11819C13.7762 9.07823 13.8658 9.03053 13.9483 8.97768C14.034 8.92096 14.1146 8.85329 14.1894 8.77852C14.3956 8.56454 14.529 8.29448 14.5696 8.00573C14.6096 7.70989 14.5497 7.39923 14.3685 7.12143C14.3157 7.04087 14.25 6.96223 14.1733 6.88554C13.8903 6.61161 13.5358 6.52718 13.1594 6.43823C12.8835 6.37442 12.5909 6.30481 12.4466 6.15657C12.4227 6.13272 12.4047 6.10178 12.3937 6.06505C12.3757 6.01026 12.3718 5.94839 12.3847 5.8878C12.3976 5.83108 12.4246 5.77823 12.4672 5.73634C12.502 5.70346 12.5497 5.67446 12.6096 5.65384C12.6335 5.64675 12.6573 5.63901 12.6773 5.63386C12.736 5.61903 12.7978 5.61001 12.8597 5.60614H12.9106C13.0131 5.60614 13.1149 5.62225 13.2065 5.65577C13.3289 5.70153 13.4275 5.7821 13.4675 5.90069C13.4727 5.91358 13.4765 5.92647 13.4785 5.9355C13.55 6.22038 13.8368 6.39376 14.1217 6.32479C14.4066 6.25583 14.5806 5.96643 14.511 5.68348C14.5 5.63772 14.4871 5.59776 14.4743 5.55909C14.3189 5.10083 13.9773 4.80821 13.5719 4.65868C13.5171 4.6387 13.4604 4.62001 13.4018 4.60583V4.28421C13.4018 3.9903 13.1646 3.75247 12.87 3.75247C12.5761 3.75247 12.3383 3.9903 12.3383 4.28421V4.62581C12.3144 4.6329 12.2906 4.64063 12.2667 4.64772C12.0515 4.72249 11.8703 4.83593 11.726 4.97643C11.5249 5.17173 11.3992 5.41278 11.3444 5.6635C11.2916 5.91036 11.3064 6.16946 11.3863 6.40729C11.4469 6.58841 11.5468 6.75598 11.6841 6.89714C12.0476 7.26968 12.4955 7.37602 12.9171 7.47464C13.1452 7.52942 13.3611 7.57905 13.4308 7.64802C13.4488 7.66477 13.4636 7.68282 13.4785 7.70473C13.5133 7.75565 13.5242 7.81237 13.5171 7.86522C13.5081 7.9271 13.4772 7.98768 13.4275 8.0386C13.4108 8.05536 13.3908 8.07147 13.3669 8.08823C13.336 8.10628 13.3051 8.12303 13.2722 8.13786C13.124 8.19973 12.9396 8.21456 12.7604 8.16557C12.5832 8.11788 12.4118 8.00509 12.2835 7.80915C12.2448 7.7505 12.2107 7.68669 12.181 7.61708C12.0695 7.34509 11.7569 7.21682 11.4869 7.33026C11.2161 7.44112 11.0866 7.75178 11.2 8.02378ZM15.8697 6.90036C15.8697 4.55427 17.7826 2.6413 20.1287 2.6413C22.4748 2.6413 24.3878 4.55427 24.3878 6.90036C24.3878 9.24645 22.4748 11.1594 20.1287 11.1594C17.7826 11.1594 15.8697 9.24581 15.8697 6.90036ZM17.8007 6.86942L19.374 8.44272C19.5822 8.65091 19.9186 8.65091 20.1268 8.44272L22.4581 6.11145C22.6643 5.90327 22.6643 5.56682 22.4581 5.35864C22.2499 5.15046 21.9115 5.15046 21.7052 5.35864L19.7504 7.3135L18.5535 6.11661C18.3453 5.90843 18.0089 5.90843 17.8007 6.11661C17.5925 6.32479 17.5925 6.66059 17.8007 6.86942Z"
                      fill="white"
                    />
                  </svg>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};
